
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEnergyHydrogen as ObiEnergyHydrogenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-energy-hydrogen.js';
 
 
 

 
 export const ObiEnergyHydrogen = createComponent({
   react: React,
   tagName: 'obi-energy-hydrogen',
   elementClass: ObiEnergyHydrogenElement,
   events: {
     
   }
  });
 
 